import { createRouter, createWebHistory } from 'vue-router';

// Lazy loading components
const Homepage = () => import('../views/homepageView.vue');
const Billing = () => import('../views/billingView.vue');
const CPQ = () => import('../views/CPQView.vue');
const Catalog = () => import('../views/CatalogView.vue');
const Customer360 = () => import('../views/Customer360View.vue');
const Order = () => import('../views/OrderView.vue');
const Ticketing = () => import('../views/TicketingView.vue');
const Uikitpage = () => import('../views/uikitpageView.vue');
const RuleEngine = () => import('../views/ruleEngineView.vue');
const Blog = () => import('../views/Blog/mainBlogPage.vue');
const BlogDetail = () => import('../views/Blog/blogDetailedPage.vue');
const privacyPolicy = () => import('../views/privacyPolicy.vue');

const routes = [
  {
    path: '/',
    name: 'homepage',
    component: Homepage,
    meta: {
      title: 'Homepage - Halleyx',
      description:
        'AI-Driven SaaS BSS Platform We empower telecom operators and MVNO/Es to finally “let go” of customizations.',
      canonical: 'https://www.halleyx.com/', // Add the canonical URL
    },
  },

  {
    path: '/index.html',
    redirect: '/',  // This is hostinger default route, Redirect to home page
  },

    {
    path: '/decision-manager',
    name: 'decision-manager',
    component: RuleEngine,
    meta: {
      title: 'Decision Manager - Halleyx',
      description: 'Explore the decision manager features of Halleyx.',
      canonical: 'https://www.halleyx.com/decision-manager', // Add the canonical URL
    },
  },

      {
    path: '/billing',
    name: 'billing',
    component: Billing,
    meta: {
      title: 'Billing - Halleyx',
      description: 'Simplify Your Telecom Billing in One Place',
      canonical: 'https://www.halleyx.com/billing', // Add the canonical URL
    },
  },
  
  {
    path: '/CPQ',
    name: 'CPQ',
    component: CPQ,
    meta: {
      title: 'CPQ - Halleyx',
      description: 'Get Quotes Right Every Time with Configure Price Quote (CPQ)',
      canonical: 'https://www.halleyx.com/CPQ', // Add the canonical URL
    },
  },

    {
    path: '/Catalog',
    name: 'Catalog',
    component: Catalog,
    meta: {
      title: 'Catalog - Halleyx',
      description: 'Keep All Your Products in One Place',
      canonical: 'https://www.halleyx.com/Catalog', // Add the canonical URL
    },
  },

  {
    path: '/Customer360',
    name: 'Customer360',
    component: Customer360,
    meta: {
      title: 'Customer360 - Halleyx',
      description: 'Know Your Customers Like Never Before',
      canonical: 'https://www.halleyx.com/Customer360', // Add the canonical URL
    },
  },

    {
    path: '/Order',
    name: 'Order',
    component: Order,
    meta: {
      title: 'Order - Halleyx',
      description: 'Streamline Every Order, Every Time',
      canonical: 'https://www.halleyx.com/Order', // Add the canonical URL
    },
  },

  {
    path: '/Ticketing',
    name: 'Ticketing',
    component: Ticketing,
    meta: {
      title: 'Ticketing - Halleyx',
      description: 'Effortless Issue Resolution for Telecom Providers with Halleyx Ticketing',
      canonical: 'https://www.halleyx.com/Ticketing', // Add the canonical URL
    },
  },

  {
    path: '/blog',
    name: 'blog',
    component: Blog,
    meta: {
      title: 'Blog - Halleyx',
      description: 'Read the latest articles and updates on our blog.',
      canonical: 'https://www.halleyx.com/blog', // Add the canonical URL
    },
  },
  {
    path: '/ui-kit',
    name: 'ui-kit',
    component: Uikitpage,
    meta: {
      title: 'UI Kit - Halleyx',
      description: 'UI Kit components for Halleyx.',
      canonical: 'https://www.halleyx.com/ui-kit', // Add the canonical URL
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: privacyPolicy,
    meta: {
      title: 'Privacy policy - Halleyx',
      description: `Halleyx's privacy policy`,
      canonical: 'https://www.halleyx.com/privacy-policy', // Add the canonical URL
    },
  },
  {
    path: '/blog/:id',
    name: 'blog-detail',
    component: BlogDetail,
    meta: {
      title: 'Blog Detail - Halleyx',
      description: 'Read detailed articles on our blog.',
      canonical: (route) => `https://www.halleyx.com/blog/${route.params.id}`, // Dynamic canonical URL
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.description) {
    document
      .querySelector('meta[name="description"]')
      .setAttribute('content', to.meta.description);
  }
  if (to.meta.canonical) {
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute(
        'href',
        typeof to.meta.canonical === 'function'
          ? to.meta.canonical(to)
          : to.meta.canonical
      );
    } else {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute(
        'href',
        typeof to.meta.canonical === 'function'
          ? to.meta.canonical(to)
          : to.meta.canonical
      );
      document.head.appendChild(link);
    }
  }
  next();
});

export default router;
